export function MobileContainer ({children})
{
    return(
        <div style={{minHeight:"100dvh", height:"100%", 
        width:"100%", minWidth:"100dvw", 
        maxHeight:"100%", maxWidth:"100%",
        /*display: "flex", justifyContent:"center", 
        alignItems:"center", overflow:"hidden",*/
        }}>
            {children}
        </div>
    );
}